import { call, put } from "redux-saga/effects";
import { API_URLS, extractErrorMessage } from "../../../config";
import { turnOffLoading, } from "../../redux/slices/adminListSlice";
import { CallApi } from "./api/callApi";

export function* createEmployeeSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.USERS.EMPLOYEE.ROUTE, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            yield put(turnOffLoading())
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(turnOffLoading())

        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* createEmployeeLeaveSaga(action) {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, API_URLS.USERS.LEAVES.ASSIGN_LEAVE, data?.data, data?.token)
        // //console.log(resp);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            // yield put(turnOffLoading())
            // action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(turnOffLoading())

        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* getEmployeeLeaveSaga(action) {
    try {
        const { token, data: { id, ...d } } = action.payload;

        const resp = yield call(CallApi.GET, `${API_URLS.USERS.LEAVES.ASSIGN_LEAVE}/${id}`, d, token)
        // //console.log(resp);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            // yield put(turnOffLoading())
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(turnOffLoading())

        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* updateEmployeeLeaveSaga(action) {
    try {
        const { token, data: { id, data: { ...d } } } = action.payload;


        const resp = yield call(CallApi.PATCH, `${API_URLS.USERS.LEAVES.ASSIGN_LEAVE}/${id}`, d, token)
        // //console.log(resp);
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            // yield put(turnOffLoading())
            // action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(turnOffLoading())

        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* updateEmployeeSaga(action) {
    try {
        const pa = action.payload;
        const { data, token } = pa;
        const { id, ...uEmp } = data
        const resp = yield call(CallApi.PATCH, `${API_URLS.USERS.EMPLOYEE.ROUTE}/${id}`, uEmp, token)
        if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.success) {
            // //console.log(resp.data.data)
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            yield put(turnOffLoading())
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(turnOffLoading())
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}